import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';
import { PersonCollectionForm } from '../forms/PersonCollectionForm';
import IForm from '../../../types/IForm';

type PersonCollectionEditProps = { form: IForm };
function PersonCollectionEdit({ form }: PersonCollectionEditProps) {
  const { delayedRefresh } = useRefreshBlock();

  return <PersonCollectionForm refreshBlock={delayedRefresh} form={form} />;
}

export const PersonCollectionEditView = asFetchableView(PersonCollectionEdit);
export type PersonCollectionEditView = ComponentProps<typeof PersonCollectionEditView>;
